export default "__VITE_ASSET__CUzyp_jR__"